<div class="page-header">
  <div class="page-header-title">{{ 'title.center-detail' | translate }}</div>
</div>
<!-- center form -->
<form class="center-form gigantix-form" [formGroup]="formCenter">
  <div class="center-name flex gap-5">
    <!-- name -->
    <input type="text" [formControl]="fC['name']" class="gigantix-input w-full"
      [placeholder]="'field.center' | translate" pInputText />
  </div>
  <div class="flex gap-2 flex-col mt-4">
    <!-- province -->
    <input type="text" [formControl]="fC['province']" class="gigantix-input w-full"
      [placeholder]="'field.province' | translate" pInputText />
    <!-- town -->
    <input type="text" [formControl]="fC['town']" class="gigantix-input w-full"
      [placeholder]="'field.town' | translate" pInputText />
    <!-- contactPhone -->
    <input type="text" [formControl]="fC['contactPhone']" class="gigantix-input w-full"
      [placeholder]="'field.phone' | translate" pInputText />
  </div>
</form>
<!-- students table -->
<section class="mt-4">
  <div class="page-subheader">
    <div class="page-subheader-title">{{ 'field.students' | translate }}</div>
    <div class="page-subheader-search flex gap-2">
      <app-search-field></app-search-field>
      <p-button icon="pi pi-plus" class="add-button" severity="primary" rounded (click)="addStudent()" [disabled]="isEditing"
        [pTooltip]="'button.add-student' | translate" tooltipEvent="hover" tooltipPosition="top" />
    </div>
  </div>
  <p-table
    #studentsTable
    [value]="students()"
    dataKey="id"
    [rows]="5"
    [paginator]="true"
    [paginatorDropdownAppendTo]="'body'"
    [rowsPerPageOptions]="[5, 10, 25, 50]"
    [tableStyle]="{ 'min-width': '600px' }"
    editMode="row"
    [editingRowKeys]="editingRowKeys"
    stripedRows
  >
    <ng-template #header>
      <tr>
        <th pSortableColumn="firstname">
          {{ 'field.firstname' | translate }}
        </th>
        <th pSortableColumn="lastname">
          {{ 'field.lastname' | translate }}
        </th>
        <th pSortableColumn="birthDate" style="min-width: 200px">
          {{ 'field.birthDate' | translate }}
        </th>
        <th style="width: 5rem"></th>
      </tr>
    </ng-template>
    <ng-template #body let-student let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="student">
        <!-- firstname -->
        <td>
          <p-cellEditor>
            <ng-template #input>
              <input pInputText type="text" [(ngModel)]="student.firstname" />
            </ng-template>
            <ng-template #output>
              {{ student.firstname }}
            </ng-template>
          </p-cellEditor>
        </td>
        <!-- lastname -->
        <td>
          <p-cellEditor>
            <ng-template #input>
              <input pInputText type="text" [(ngModel)]="student.lastname" />
            </ng-template>
            <ng-template #output>
              {{ student.lastname }}
            </ng-template>
          </p-cellEditor>
        </td>
        <!-- birthDate -->
        <td>
          <p-cellEditor>
            <ng-template #input>
              <p-datepicker appendTo="body" [(ngModel)]="student.birthDate" [showIcon]="true" 
                dateFormat="dd/mm/yy" [firstDayOfWeek]="1"></p-datepicker>
            </ng-template>
            <ng-template #output>
              {{ student.birthDate | date: 'dd/MM/yyyy'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <!-- actions -->
        <td>
          <div class="flex items-center justify-center gap-2">
            @if(!isEditing) {
              <p-button pInitEditableRow icon="pi pi-pencil" rounded severity="secondary"
                [pTooltip]="'button.edit' | translate" tooltipPosition="top"
                (click)="onRowEditInit(student)"></p-button>
              <p-button icon="pi pi-trash" rounded severity="danger"
                [pTooltip]="'button.delete' | translate" tooltipPosition="top"
                (click)="deleteStudent($event, student)"></p-button>
            }
            @if(isEditing && editing) {
              <p-button pSaveEditableRow icon="pi pi-check" rounded severity="secondary"
                [pTooltip]="'button.save' | translate" tooltipPosition="top"
                [disabled]="!student.firstname || !student.lastname" (click)="onRowEditSave(student)"></p-button>
              <p-button pCancelEditableRow icon="pi pi-times" rounded severity="secondary"
                [pTooltip]="'button.cancel' | translate" tooltipPosition="top"
                (click)="onRowEditCancel(student, ri)"></p-button>
            }
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">{{ 'no-item.students' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
  <div class="footer-buttons">
    <p-button [label]="'button.cancel' | translate" styleClass="gigantix-button button-cancel" (click)="cancel()"></p-button>
    <p-button [label]="'button.save' | translate" styleClass="gigantix-button button-confirm" (click)="save()"></p-button>
  </div>
</section>

<p-confirmpopup />
